import { EngineMark } from '@/components/engine-mark'
import { ENGINE_FILTERS, type EngineFilter } from '@/lib/site-data'
import { cn } from '@/lib/utils'

const LABELS: Record<EngineFilter, string> = { all: 'All', google: 'Google', bing: 'Bing' }

export function parseEngineFilter(value: unknown): EngineFilter | undefined {
  return ENGINE_FILTERS.find((engine) => engine === value)
}

/**
 * Which engine a table is read from. Drawn only where a site has more than one:
 * a choice between Google and Google is a control that does nothing.
 */
export function EngineFilterControl({
  value,
  engines,
  onChange,
  size = 'default',
}: {
  value: EngineFilter
  engines: readonly string[] | undefined
  onChange: (next: EngineFilter) => void
  /** `sm` fits a panel header strip. */
  size?: 'default' | 'sm'
}) {
  if (!engines || engines.length < 2) return null

  return (
    <div
      className={cn(
        'inline-flex shrink-0 items-center rounded-md border border-border bg-card p-0.5',
        size === 'sm' ? 'h-7' : 'h-9',
      )}
    >
      {ENGINE_FILTERS.map((option) => (
        <button
          key={option}
          type="button"
          aria-pressed={value === option}
          onClick={() => onChange(option)}
          className={cn(
            'inline-flex cursor-pointer items-center gap-1.5 rounded-[4px] transition-colors',
            size === 'sm' ? 'px-2 py-0.5 text-[12px]' : 'px-2.5 py-1 text-[13px]',
            value === option
              ? 'bg-accent text-foreground'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {option !== 'all' && <EngineMark engine={option} />}
          {LABELS[option]}
        </button>
      ))}
    </div>
  )
}
